<template>
  <div class="linear-chart">
    <p class="label">{{$props.label}}</p>
    <div class="value">
      <slot name="value">{{$props.valueLabel}}</slot>
    </div>
    <div class="bar">
      <div class="progress" :style="calculatedProgress" :class="barClasses"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'linear-chart',
  props: {
    maxValue: {
      type: [Number, String],
      default: 100
    },
    currentValue: {
      type: [Number, String],
      default: 0
    },
    unlimited: Boolean,
    animationDelay: {
      type: [Number, String],
      default: 0
    },
    label: String,
    valueLabel: String
  },
  computed: {
    calculatedProgress () {
      if (this.$props.unlimited) {
        return {
          'max-width': '100%',
          '--animation-delay': `${this.$props.animationDelay}s`
        }
      }
      return {
        'max-width': `${100 * Number(this.$props.currentValue) / Number(this.$props.maxValue)}%`,
        '--animation-delay': `${this.$props.animationDelay}s`
      }
    },
    barClasses () {
      return {
        unlimited: this.$props.unlimited,
        zero: Number(this.$props.currentValue) === 0
      }
    }
  }
}
</script>

<style scoped lang="scss">
.linear-chart {
  display: block;
  align-items: center;
  padding-top: 1rem;
  position: relative;

  @media (map_get($breakpoints, sm)) {
    display: flex;
    padding-top: 3.5rem;
  }

  .label {
    max-width: 66%;
    font-size: 1.6rem;
    font-weight: 600;
    color: $text;
    margin-bottom: 0.5rem;
    line-height: 1.25;

    @media (map_get($breakpoints, sm)) {
      margin-bottom: 0;
      flex-basis: 33%;
      min-width: 33%;
      max-width: 33%;
    }
  }

  .value {
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-1.5rem);
    text-align: right;
    font-size: 1.2rem;
    font-weight: 600;
    text-transform: uppercase;
  }

  .bar {
    flex: 1 1 auto;
    height: 2.4rem;
    position: relative;
    overflow: hidden;
    border-radius: 2rem;

    @media (map_get($breakpoints, sm)) {
      margin-left: 2rem;
    }

    &::before {
      position: absolute;
      content: '';
      background-color: $white;
      top: 0.2rem;
      left: 0;
      right: 0;
      height: 2rem;
      width: 100%;
      border-radius: 2rem;
    }

    .progress {
      position: absolute;
      top: 0;
      height: 2.4rem;
      border-radius: 2rem;
      left: 0;
      width: 0;
      background-image: linear-gradient(to right, #b10d28, #cf1432 9%, #ed1a3b 25%, #f58220);
      animation: grow 800ms forwards ease-in-out;
      animation-delay: var(--animation-delay);

      &.zero {
        min-width: 0;
        animation: none;
      }

      &.unlimited {
        background-image: linear-gradient(to right, #2b5585, #56ccc7 51%, #25d7a6);
      }
    }
  }
}

@keyframes grow {
  0% {
    min-width: 0;
    width: 0 !important;
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  100% {
    width: 100%;
    min-width: 2.4rem;
  }
}
</style>
